<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_fj.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_fj.png'
import list_img1 from '../../images/download/down-fj1.jpg'
import list_img2 from '../../images/download/down-fj2.jpg'
import list_img3 from '../../images/download/down-fj3.jpg'
import cut_img1 from '../../images/download/fjjt1.png'
import cut_img2 from '../../images/download/fjjt2.png'
import cut_img3 from '../../images/download/fjjt3.png'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'八闽福建麻将',
                size:'167.8',
                load_count:'267',
                desp:'八闽福建麻将是一款休闲类棋牌游戏。时尚简约的棋牌画面，真人实时对战玩法，陪伴您快了每一天！八闽福建麻将集合福建多个地区的麻将玩法。福州麻将、泉州游金麻将、漳州麻将，闽清玩法，红中麻将等多种本地化玩法。福建地区特有的补花、抢金、开金玩法，规则简单容易上手，但是乐趣无穷。',
                ios_url:'http://app1.xlsymj.com/?downloadfrom=fujian',
                android_url:'http://app1.xlsymj.com/?downloadfrom=fujian',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
